import React from "react";
import { ErrorMessage, Field } from "formik";
import { therapeuticApproachSchema } from "ps-shared";
import * as yup from "yup";

import { FormGroup, Label } from "reactstrap";

type TherapeuticApproachSchema = yup.InferType<typeof therapeuticApproachSchema>;
interface TherapeuticApproachProps {
  values: TherapeuticApproachSchema;
}

export default class TherapeuticApproachForm extends React.Component<TherapeuticApproachProps> {
  // tslint:disable:max-line-length
  public render() {
    return (
      <>
        <FormGroup className="mb-3">
          <Label for="bio">About your clinic:</Label>
          <br />
          <Field
            placeholder="Tell us about your clinic!"
            type="text"
            component="textarea"
            name="bio"
            className="form-control"
          />
          <ErrorMessage name="bio" component="div" className="position-relative form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="approach">Therapeutic Approach:</Label>
          <br />
          <Field
            placeholder="Describe the therapeutic approach of your clinic..."
            type="text"
            name="approach"
            component="textarea"
            className="form-control"
          />
          <ErrorMessage name="approach" component="div" className="position-relative form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="work">How does the clinic work with Clients:</Label>
          <br />
          <Field
            placeholder="How does the clinic work with clients?"
            type="text"
            name="work"
            component="textarea"
            className="form-control"
          />
          <ErrorMessage name="work" component="div" className="position-relative form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="programs">Programs offered:</Label>
          <br />
          <Field
            placeholder="Describe any programs you offer at your clinic"
            type="text"
            name="programs"
            component="textarea"
            className="form-control"
          />
          <ErrorMessage name="programs" component="div" className="position-relative form-feedback" />
        </FormGroup>
      </>
    );
  }
}
